<mat-card appearance="outlined" class="ao-card">
  <span #matCardHeader></span>
  <mat-card-header class="d-block pb-2">
    <div class="d-block w-100" style="padding-right: 2rem">
      <div class="d-flex align-items-center justify-between w-100 mb-2">
        <div>
          <ol
            class="breadcrumb mb-0 ps-0 d-flex align-items-center futura-book"
          >
            <li class="breadcrumb-item d-flex align-items-center">
              <a [routerLink]="['/v2/payables']">Payables</a>
            </li>
            <ng-container *ngIf="vendorId; else distributorBlock">
              <li *ngIf="vendor?.name" class="breadcrumb-item gray-color">
                <ng-container *ngIf="vendor?.images?.length; else nameBlock">
                  <app-product-image
                    [image]="vendor.images[0]"
                    [alt]="vendor.name"
                    class="logo"
                  ></app-product-image>
                </ng-container>
                <ng-template #nameBlock>
                  {{ vendor.name }}
                </ng-template>
              </li>
            </ng-container>
            <ng-template #distributorBlock>
              <li *ngIf="vendor?.name" class="breadcrumb-item gray-color">
                <ng-container *ngIf="vendor?.images?.length; else distributorName">
                  <app-product-image
                    [image]="vendor.images[0]"
                    [alt]="vendor.name"
                    class="logo"
                  ></app-product-image>
                </ng-container>
                <ng-template #distributorName>
                  {{ vendor.name }}
                </ng-template>
              </li>
            </ng-template>
          </ol>
        </div>
        <div class="select-box">
          <mat-radio-group class="status" aria-label="Select status" value="paid">
            <mat-radio-button value="unpaid" color="primary" (click)="showUnPaid()">Unpaid</mat-radio-button>
            <mat-radio-button value="paid" color="primary" [checked]="true">Paid</mat-radio-button>
          </mat-radio-group>
        </div>
        <div *ngIf="searchControl">
          <form class="search-box relative">
            <input
              type="text"
              [formControl]="searchControl"
              class="input-search d-block dark"
              placeholder="Search Orders"
            />
            <button type="submit" class="icon">
              <mat-icon>search</mat-icon>
            </button>
          </form>
        </div>
      </div>
    </div>
  </mat-card-header>
  <mat-card-content class="mat-mdc-card-content">
    <div class="mat-elevation-z0 mat-table mt-18">
      <table
        *ngIf="displayedColumns?.length"
        mat-table
        matSort
        [matSortActive]="sort.active"
        [matSortDirection]="sort.direction"
        [dataSource]="dataSource | async"
        class="ao-job-table"
        (matSortChange)="onSortChange($event)"
      >

        <!-- Vendor Column -->
        <ng-container matColumnDef="vendor">
          <th mat-header-cell *matHeaderCellDef class="ao-header-cell center">
            Vendor
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="ao-table-cell center"
          >
            {{ element.vendorName }}
          </td>
        </ng-container>

        <!-- Group Id Column -->
        <ng-container matColumnDef="groupId">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="ao-header-cell center"
            mat-sort-header="groupId"
          >
            Group #
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="ao-table-cell center"
          >
            <div class="d-flex align-items-center">
              {{ element.groupId }}
            </div>
          </td>
        </ng-container>

        <!-- Invoice Column -->
        <ng-container matColumnDef="invoiceNumber">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="ao-header-cell center"
            mat-sort-header="invoiceNumber"
          >
            Invoice #
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="ao-table-cell center"
          >

                {{ element.invoiceNumber }}

          </td>
        </ng-container>

        <!-- Invoice Date Column -->
        <ng-container matColumnDef="invoiceDate">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="ao-header-cell center"
            mat-sort-header="date"
          >
            Invoice Date
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="ao-table-cell center"
          >
            <ng-container *ngIf="!element.header">
              {{ element.date | date: 'shortDate' }}
            </ng-container>
          </td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="ao-header-cell center"
            mat-sort-header="status"
          >
            Status
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="ao-table-cell center ao-status"
          >
            {{ element.status }}
          </td>
        </ng-container>

        <!-- Date Column -->
        <ng-container matColumnDef="datePaid">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="ao-header-cell center"
            mat-sort-header="datePaid"
          >
            Date
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="ao-table-cell center"
          >
            <ng-container *ngIf="element.header; else rowBlock">
              {{ element.datePaid | date: 'shortDate' }}
            </ng-container>
            <ng-template #rowBlock>
              {{ element.date | date: 'shortDate' }}
            </ng-template>
          </td>
        </ng-container>

        <!-- Shipping Column -->
        <ng-container matColumnDef="shipping">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="ao-header-cell center"
            mat-sort-header="shipping"
          >
            Shipping
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="ao-table-cell center td-input"
          >
          {{ element.header ? '' : (element.shipping | currency) }}
          </td>
        </ng-container>

        <!-- Tax Column -->
        <ng-container matColumnDef="tax">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="ao-header-cell center"
            mat-sort-header="tax"
          >
            Tax
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="ao-table-cell center td-input"
          >
          {{ element.header ? '' : (element.tax | currency) }}
          </td>
        </ng-container>

        <!-- Payments Column -->
        <ng-container matColumnDef="payments">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header="partialPayment"
            class="ao-header-cell center"
          >
            Amt. Paid
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="ao-table-cell center"
          >
            {{ element.partialPayment | currency }}
          </td>
        </ng-container>

        <!-- Amount To Pay Column -->
        <ng-container matColumnDef="amountToPay">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="ao-header-cell center"
          >
            To Pay
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="ao-table-cell center"
          >
                  {{ element.amountToPay | currency }}
          </td>
        </ng-container>

        <!-- Total Column -->
        <ng-container matColumnDef="total">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header="total"
            class="ao-header-cell center"
          >
            Total
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="ao-table-cell center"
          >
            {{ element.total | currency }}
          </td>
        </ng-container>

        <!-- Amount Due Column -->
        <ng-container matColumnDef="amountDue">
          <th mat-header-cell *matHeaderCellDef class="ao-header-cell center">
            Amt. Due
          </th>

          <td
            mat-cell
            *matCellDef="let element"
            class="ao-table-cell center"
          >
            <span [matTooltip]="'Total: $' + element.total"><strong>{{
              element.amountDue | currency
            }}</strong></span>
          </td>
        </ng-container>

        <!-- Options Column -->
        <ng-container matColumnDef="options">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="ao-header-cell center"
          ></th>
          <td
            mat-cell
            *matCellDef="let element"
            class="ao-table-cell center"
          >
            <mat-icon
              *ngIf="element.header; else optionsBlock"
              class="pointer icon"
              (click)="printVendorOrders(element._id)"
              [matTooltip]="'Print group invoice'"
            >
              print
            </mat-icon>
            <ng-template #optionsBlock>
                <img class="ao-row-icon pointer icon" src="assets/images/ao-icon-view.svg" alt="" (click)="viewOrder(element._id)">
            </ng-template>
          </td>
        </ng-container>

        <!-- Log Column -->
        <ng-container matColumnDef="log">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="ao-header-cell center"
          ></th>
          <td
            mat-cell
            *matCellDef="let element"
            class="ao-table-cell center"
          >
            <app-payables-list-menu
              *ngIf="!element.header"
              [payable]="element"
              [type]="'log'"
            ></app-payables-list-menu>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns"
          class="ao-header-row th"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; let odd = odd; columns: displayedColumns"
          class="ao-table-row"
          [class.ao-row-alt]="odd"
          [class.tr-light]="row.header"
        ></tr>
      </table>
    </div>
  </mat-card-content>
</mat-card>
